<div class="password-meter">
    <div class="password-meter__bar">
        <div *ngFor="let level of strengthLevels" [ngClass]="level" class="strength-bar"></div>
    </div>
</div>
